/* MONTKUSH native storefront prompts. No third-party runtime or customer-facing API. */
(function () {
  'use strict';

  var root = document.getElementById('mk-native-prompts');
  var configNode = document.getElementById('mk-native-prompts-config');
  if (!root || !configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (_error) {
    return;
  }

  var pagePath = root.getAttribute('data-page-path') || window.location.pathname || '/';
  var productHandle = root.getAttribute('data-product-handle') || '';
  var cartImage = root.getAttribute('data-cart-image') || '';
  var quizImage = root.getAttribute('data-quiz-image') || '';
  var activePrompt = null;
  var intentEvaluated = false;
  var sessionPrefix = 'mkNativePrompt:';

  function safely(storage, operation, key, value) {
    try {
      if (operation === 'get') return storage.getItem(key);
      if (operation === 'set') storage.setItem(key, value);
      if (operation === 'remove') storage.removeItem(key);
    } catch (_error) {
      return null;
    }
    return null;
  }

  function sessionGet(key) { return safely(window.sessionStorage, 'get', sessionPrefix + key); }
  function sessionSet(key, value) { safely(window.sessionStorage, 'set', sessionPrefix + key, value); }
  function localGet(key) { return safely(window.localStorage, 'get', sessionPrefix + key); }
  function localSet(key, value) { safely(window.localStorage, 'set', sessionPrefix + key, value); }

  function toInteger(value, fallback) {
    var parsed = Number(value);
    return Number.isInteger(parsed) ? parsed : fallback;
  }

  function isInternalPath(value) {
    return typeof value === 'string' && value.indexOf('/') === 0 && value.indexOf('//') !== 0;
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function getPageViews() {
    var current = toInteger(sessionGet('pageViews'), 0) + 1;
    sessionSet('pageViews', String(current));
    return current;
  }

  var pageViews = getPageViews();

  function isSmallScreen() {
    return window.matchMedia && (window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(pointer: coarse)').matches);
  }

  function eligiblePathForIntent() {
    return !/^\/(?:account|challenge|checkouts?)(?:\/|$)/i.test(pagePath) && !/^\/pages\/find-my-formula(?:\/|$)/i.test(pagePath);
  }

  function displayCount(type) {
    return toInteger(localGet('displayCount:' + type), 0);
  }

  function canShow(type, maxDisplays) {
    if (activePrompt || sessionGet('shown:' + type)) return false;
    return displayCount(type) < toInteger(maxDisplays, 1);
  }

  function markShown(type) {
    sessionSet('shown:' + type, '1');
    localSet('displayCount:' + type, String(displayCount(type) + 1));
  }

  function discountLink(code, redirect) {
    if (!/^[A-Za-z0-9_-]{1,64}$/.test(String(code || '')) || !isInternalPath(redirect)) return '';
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      }
      textarea.remove();
    });
  }

  function makeButton(label, className) {
    var button = element('button', className, label);
    button.type = 'button';
    return button;
  }

  function trapFocus(event, wrapper) {
    if (event.key !== 'Tab') return;
    var focusable = wrapper.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function showPrompt(type, details) {
    if (activePrompt) return false;
    var isAge = type === 'age';
    var isCart = type === 'cart';
    var origin = document.activeElement;
    var backdrop = element('div', 'mk-native-prompt-backdrop');
    var dialog = element('section', 'mk-native-prompt mk-native-prompt--' + type);
    var content = element('div', 'mk-native-prompt__content');
    var title = element('h2', 'mk-native-prompt__title', details.heading || 'MONTKUSH');
    var titleId = 'mk-native-prompt-title-' + Date.now();
    title.id = titleId;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', titleId);

    if (!isAge) {
      var close = makeButton('×', 'mk-native-prompt__close');
      close.setAttribute('aria-label', 'Close this offer');
      close.addEventListener('click', function () { closePrompt('dismissed'); });
      dialog.appendChild(close);
    }

    if (details.eyebrow) content.appendChild(element('p', 'mk-native-prompt__eyebrow', details.eyebrow));
    content.appendChild(title);
    content.appendChild(element('p', 'mk-native-prompt__body', details.body || ''));

    if (isCart && details.couponCode) {
      var coupon = makeButton('', 'mk-native-prompt__coupon');
      coupon.setAttribute('aria-label', 'Copy discount code ' + details.couponCode);
      var couponLabel = element('span', 'mk-native-prompt__coupon-label', details.couponLabel || 'Copy code');
      var couponCode = element('strong', 'mk-native-prompt__coupon-code', details.couponCode);
      coupon.appendChild(couponLabel);
      coupon.appendChild(couponCode);
      coupon.addEventListener('click', function () {
        copyText(details.couponCode).then(function () {
          couponLabel.textContent = 'Copied';
          window.setTimeout(function () { couponLabel.textContent = details.couponLabel || 'Copy code'; }, 1800);
        }, function () {
          couponLabel.textContent = 'Copy failed';
          window.setTimeout(function () { couponLabel.textContent = details.couponLabel || 'Copy code'; }, 1800);
        });
      });
      content.appendChild(coupon);
    }

    var actions = element('div', 'mk-native-prompt__actions');
    if (isAge) {
      var decline = document.createElement('a');
      decline.className = 'mk-native-prompt__button mk-native-prompt__button--secondary';
      decline.href = isInternalPath(details.declineUrl) ? details.declineUrl : '/';
      decline.textContent = details.declineLabel || 'No, take me home';
      actions.appendChild(decline);
      var accept = makeButton(details.acceptLabel || 'Yes, I’m 21+', 'mk-native-prompt__button');
      accept.addEventListener('click', function () {
        var days = Math.max(1, Math.min(365, toInteger(details.rememberDays, 30)));
        localSet('ageAcknowledgement:' + productHandle, String(Date.now() + days * 86400000));
        closePrompt('accepted');
      });
      actions.appendChild(accept);
    } else {
      var cta = document.createElement('a');
      cta.className = 'mk-native-prompt__button';
      cta.href = isCart ? (discountLink(details.couponCode, details.ctaUrl || '/cart') || '/cart') : (isInternalPath(details.ctaUrl) ? details.ctaUrl : '/');
      cta.textContent = details.ctaLabel || (isCart ? 'Apply offer' : 'Take the quiz');
      actions.appendChild(cta);
    }
    content.appendChild(actions);

    if (!isAge) {
      var imageUrl = isCart ? cartImage : quizImage;
      if (imageUrl) {
        var media = element('div', 'mk-native-prompt__media');
        var image = document.createElement('img');
        image.alt = '';
        image.decoding = 'async';
        image.src = imageUrl;
        media.appendChild(image);
        dialog.appendChild(media);
      }
    }
    dialog.appendChild(content);
    backdrop.appendChild(dialog);
    root.appendChild(backdrop);
    document.documentElement.classList.add('mk-native-prompt-open');
    markShown(type);

    var keydown = function (event) {
      if (event.key === 'Escape' && !isAge) {
        event.preventDefault();
        closePrompt('dismissed');
        return;
      }
      trapFocus(event, dialog);
    };
    document.addEventListener('keydown', keydown);
    if (!isAge) {
      backdrop.addEventListener('click', function (event) {
        if (event.target === backdrop) closePrompt('dismissed');
      });
    }

    activePrompt = {
      type: type,
      close: function () {
        document.removeEventListener('keydown', keydown);
        backdrop.remove();
        document.documentElement.classList.remove('mk-native-prompt-open');
        activePrompt = null;
        if (origin && typeof origin.focus === 'function') origin.focus();
      },
    };

    window.setTimeout(function () {
      var primary = dialog.querySelector('.mk-native-prompt__close, .mk-native-prompt__button');
      if (primary) primary.focus();
    }, 0);
    return true;
  }

  function closePrompt() {
    if (activePrompt) activePrompt.close();
  }

  function ageAcknowledged() {
    var until = toInteger(localGet('ageAcknowledgement:' + productHandle), 0);
    return until > Date.now();
  }

  function showAgeGateIfNeeded() {
    var age = config.ageGate || {};
    var productHandles = Array.isArray(age.productHandles) ? age.productHandles : [];
    if (!age.enabled || !productHandle || productHandles.indexOf(productHandle) === -1 || ageAcknowledged()) return false;
    return showPrompt('age', age);
  }

  function cartEligible() {
    var cart = config.cartRecovery || {};
    if (!cart.enabled || !eligiblePathForIntent() || !canShow('cart', cart.maxDisplaysPerVisitor)) return Promise.resolve(false);
    return window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        return Boolean(data && data.item_count > 0 && Number(data.total_price || 0) >= toInteger(cart.minCartCents, 0));
      })
      .catch(function () { return false; });
  }

  function quizEligible() {
    var quiz = config.exitQuiz || {};
    var minimumPages = isSmallScreen() ? toInteger(quiz.mobileMinPages, 3) : toInteger(quiz.desktopMinPages, 4);
    return Boolean(quiz.enabled && eligiblePathForIntent() && pageViews >= minimumPages && canShow('quiz', quiz.maxDisplaysPerVisitor));
  }

  function evaluateIntent() {
    if (intentEvaluated || activePrompt) return;
    intentEvaluated = true;
    cartEligible().then(function (hasCart) {
      if (hasCart) {
        showPrompt('cart', config.cartRecovery || {});
      } else if (quizEligible()) {
        showPrompt('quiz', config.exitQuiz || {});
      }
    });
  }

  function bindDesktopIntent() {
    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget || event.clientY > 0) return;
      evaluateIntent();
    });
  }

  function bindMobileIntent() {
    var idleTimer;
    var timeout = Math.max(
      toInteger((config.exitQuiz || {}).mobileIdleSeconds, 20),
      toInteger((config.cartRecovery || {}).mobileIdleSeconds, 20)
    ) * 1000;
    function resetIdle() {
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(evaluateIntent, timeout);
    }
    ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach(function (eventName) {
      window.addEventListener(eventName, resetIdle, { passive: true });
    });
    resetIdle();
  }

  function begin() {
    if (showAgeGateIfNeeded()) return;
    if (!eligiblePathForIntent()) return;
    if (isSmallScreen()) bindMobileIntent();
    else bindDesktopIntent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { once: true });
  else begin();
}());
